import classNames from 'classnames';
import * as React from 'react';
import { Collapse } from 'react-collapse';

import { getTranslation, keys } from '../../../../Resources/Translations';
import { ViagraFormAnswersButtons } from './ViagraFormAnswersButtons';
import { Question, QuestionState } from './ViagraFormTypings';

interface ViagraQuestionProps {
    question: Question;
    showErrors: boolean;
    questionIndex: number;
    setQuestionAnswer: (answer: QuestionState, questionIndex: number, subQuestionIndex?: number) => void;
}

export const ViagraFormQuestion = ({ question, showErrors, questionIndex, setQuestionAnswer }: ViagraQuestionProps) => {
    const areSubQuestionsChecked = (question: Question): boolean => {
        let areAllChecked = true;

        if (question.value !== QuestionState.WithSubQuestions) return true;

        question.subQuestions?.map((subQuestion) => {
            if (subQuestion.value === QuestionState.NotAnswered) areAllChecked = false;
        });

        return areAllChecked;
    };

    const addError = (q: Question) => {
        return (
            q.explanation && (
                <Collapse isOpened={q.value === QuestionState.Yes}>
                    <p className="ViagraForm__Explanation">{q.explanation}</p>
                </Collapse>
            )
        );
    };

    return (
        <div className="ViagraForm__QuestionLine">
            <div
                className={classNames(
                    'ViagraForm__Question',
                    showErrors && (question.value === QuestionState.NotAnswered || !areSubQuestionsChecked(question)) && 'ViagraForm__Question--NotAnswered'
                )}
            >
                <div className="ViagraForm__QuestionBox">
                    <span className="ViagraForm__QuestionNumber">{questionIndex + 1}</span>
                    <span className="ViagraForm__QuestionText ViagraForm__QuestionText--Bold">
                        {question.value === QuestionState.WithSubQuestions ? (
                            question.text
                        ) : (
                            <>
                                {question.text}*<span className="visuallyHidden">{getTranslation(keys['viagraForm.required'])}</span>
                            </>
                        )}
                    </span>
                </div>
                {question.value === QuestionState.WithSubQuestions ? (
                    question.subQuestions &&
                    question.subQuestions.map((subQuestion, j) => (
                        <div
                            className={classNames(
                                'ViagraForm__Question',
                                showErrors && subQuestion.value === QuestionState.NotAnswered && 'ViagraForm__Question--NotAnswered'
                            )}
                            key={subQuestion.text}
                        >
                            <div className="ViagraForm__QuestionBox">
                                <span className="ViagraForm__QuestionText">
                                    {subQuestion.text}*<span className="visuallyHidden">{getTranslation(keys['viagraForm.required'])}</span>
                                </span>
                            </div>
                            <ViagraFormAnswersButtons
                                questionIndex={questionIndex}
                                subQuestionIndex={j}
                                setQuestionAnswer={setQuestionAnswer}
                                question={subQuestion}
                            />
                            {addError(subQuestion)}
                        </div>
                    ))
                ) : (
                    <ViagraFormAnswersButtons questionIndex={questionIndex} setQuestionAnswer={setQuestionAnswer} question={question} />
                )}
                {question.value !== QuestionState.WithSubQuestions && addError(question)}
            </div>
        </div>
    );
};
